const initalState = {
  isLogin: false,
  token: '',
  refreshToken: '',
  hakAkses: '',
};

/**
 * @function loginReducers
 * @summary Login reducers that change the global state based on actions.
 * @param {object} state - Initial global state.
 * @param {func} action - Action object.
 * @return {object} Updated global state.
 */
const loginReducers = (state = initalState, action) => {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      return {
        ...state,
        isLogin: true,
        token: action.payload.token,
        refreshToken: action.payload.refreshToken,
      };
    case 'SET_HAK_AKSES':
      return {
        ...state,
        hakAkses: action.payload.hakAkses,
      };
    case 'RESET_STATE':
      return {
        ...state,
        isLogin: false,
        token: '',
        refreshToken: '',
        hakAkses: {},
      };
    default:
      return state;
  }
};

export default loginReducers;
